module.exports = __webpack_public_path__ + "img/DownloadAll.a33427c0.svg";